import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { ref, computed, onMounted } from "vue";
import TextInput from "../custom/TextInput.vue";
import { phoneRule, requiredRule } from "@/utils/rules";


export default /*#__PURE__*/_defineComponent({
  __name: 'PhoneNumberInput',
  props: {
    modelValue: {}
  },
  emits: ["update:modelValue"],
  setup(__props: any, { emit }) {

const props = __props;



const value = ref(props.modelValue);

const enforcePhoneFormat = () => {
  if (!value.value) return;
  let x = value.value.replace(/\D/g, "").match(/(\d{0,3})(\d{0,3})(\d{0,4})/);

  value.value = !x[2]
    ? x[1]
    : "(" + x[1] + ") " + x[2] + (x[3] ? "-" + x[3] : "");
};

onMounted(() => {
  enforcePhoneFormat();
  // Additional setup code if needed
});

const computedValue = computed({
  get: () => value.value,
  set: (newValue) => {
    value.value = newValue;
    emit("update:modelValue", newValue);
  },
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(TextInput, {
    type: "tel",
    "bg-color": '#FAFBFC',
    variant: "outlined",
    class: "form-control",
    id: "input-phone",
    label: "Phone number",
    modelValue: computedValue.value,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((computedValue).value = $event)),
    maxlength: "16",
    onInput: enforcePhoneFormat,
    rules: [_unref(phoneRule), _unref(requiredRule)],
    required: ""
  }, null, 8, ["modelValue", "rules"]))
}
}

})